var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "diaryHeader-wapper", attrs: { align: "center" } },
    [
      _c(
        "column-wrapper",
        [
          _c("assistence", {
            attrs: { title: "Asistencia" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("Asist")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("breakfast", {
            attrs: { title: "Desayuno" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("Desayuno")])
        ],
        1
      ),
      _vm._v(" "),
      _c("column-wrapper", [
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c("first-course-type", {
              attrs: { title: "1er Plato", student: _vm.student },
              on: { updatedElement: _vm.detectElementChange }
            }),
            _vm._v(" "),
            _c("first-course-value", {
              attrs: { title: "1er Plato", student: _vm.student },
              on: { updatedElement: _vm.detectElementChange }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("h3", { staticClass: "text-center" }, [_vm._v("1er Plato")])
      ]),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("second-course", {
            attrs: { title: "2º Plato" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("2º Plato")])
        ],
        1
      ),
      _vm._v(" "),
      _c("column-wrapper", [
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c("dessert-type", {
              attrs: { title: "Postre", student: _vm.student },
              on: { updatedElement: _vm.detectElementChange }
            }),
            _vm._v(" "),
            _c("dessert-value", {
              attrs: { title: "Postre", student: _vm.student },
              on: { updatedElement: _vm.detectElementChange }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("h3", { staticClass: "text-center" }, [_vm._v("Postre")])
      ]),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("milk", {
            attrs: { title: "Leche" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("Leche")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("nap", {
            attrs: { title: "Siesta" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("Siesta")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("deposition", {
            attrs: { title: "Poo" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("Poo")])
        ],
        1
      ),
      _vm._v(" "),
      _c("column-wrapper", [
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c("snack-type", {
              attrs: { title: "Merienda", student: _vm.student },
              on: { updatedElement: _vm.detectElementChange }
            }),
            _vm._v(" "),
            _c("snack-value", {
              attrs: { title: "Merienda", student: _vm.student },
              on: { updatedElement: _vm.detectElementChange }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("h3", { staticClass: "text-center" }, [_vm._v("Merienda")])
      ]),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("message-text-area", {
            attrs: { edit: true, title: "Mensaje" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("Mensaje")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ba1c4e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba1c4e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diaryType/BabyDiary/BabyDiaryHeader.vue
// module id = 276
// module chunks = 1